import { render, staticRenderFns } from "./PaymentConditions.vue?vue&type=template&id=f97032ac&"
import script from "./PaymentConditions.vue?vue&type=script&lang=js&"
export * from "./PaymentConditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports